import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <PageDescription mdxType="PageDescription">
      <h2>{`What to expect?`}</h2>
    </PageDescription>
    <Row mdxType="Row">
  <Column colLg={4} colMd={4} mdxType="Column">
        <img {...{
          "src": "/b2552f3d9094c696e953aee574de83f6/cloud.svg",
          "alt": "Grid Example"
        }}></img>
        <p style={{
          "textAlign": "center"
        }}>An introduction to the basic concepts related to cloud use cases.</p>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <img {...{
          "src": "/0b0e7e07c6150424e6d7b21815716cd7/idea.svg",
          "alt": "Grid Example"
        }}></img>
        <p style={{
          "textAlign": "center"
        }}>Information about how certain clouds take advantage of open source solutions.</p>
  </Column>
  <Column colLg={4} colMd={4} mdxType="Column">
        <img {...{
          "src": "/722c920666139d66a5e4c608bf56b308/teacher.svg",
          "alt": "Grid Example"
        }}></img>
        <p style={{
          "textAlign": "center"
        }}>Additional learning resources so you can further your understanding.</p>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      